var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsIn, IsArray, IsString, IsDateString, IsUUID, IsNotEmpty, ValidateNested, IsBoolean, } from 'class-validator';
export class WorkCalendarDate {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkCalendarDate.prototype, "date", void 0);
__decorate([
    IsIn(['workday', 'weekend', 'holiday']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkCalendarDate.prototype, "type", void 0);
export class WorkCalendar {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkCalendarDate),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WorkCalendar.prototype, "dates", void 0);
export class WorkScheduleDate {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkScheduleDate.prototype, "date", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkScheduleDate.prototype, "is_workday", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkScheduleDate.prototype, "is_holiday", void 0);
export class WorkScheduleCalendar {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkScheduleCalendar.prototype, "id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkScheduleDate),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WorkScheduleCalendar.prototype, "dates", void 0);
